// src/components/OutstationRentalDetailsPage.js
import React, { useState, useEffect,useContext } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {
  Container,
  Row,
  Col,
  Carousel,
  Button,
  Card,
  Image,
  Placeholder,
  Badge,
} from "react-bootstrap";
import { ArrowLeft } from "lucide-react";
import {
  getFirestore,
  doc,
  getDoc,
  query,
  collection,
  where,
  getDocs,
} from "firebase/firestore";
import { app } from "../FireBase";
import "../css/RoomDetailsPage.css";
import OutstationRentalModal from "../components/CabRentalModal.jsx";
import RelatedRentals from "../components/RelatedRentals.jsx";
import { AuthContext } from "../context/AuthContext";
import ProfileReminder from "../components/ProfileReminder.jsx";

const db = getFirestore(app);

export default function CabRentalDetailsPage() {
  const { id } = useParams();
    const { currentUser } = useContext(AuthContext);
  const navigate = useNavigate();
  const [pkg, setPkg] = useState(null);
  const [loading, setLoading] = useState(true);
  const [index, setIndex] = useState(0);
  const [imgLoaded, setImgLoaded] = useState({});
  const [vehicles, setVehicles] = useState([]);
  const [bookingModal, setBookingModal] = useState(false);
    const [showReminder, setShowReminder] = useState(false);

  useEffect(() => {
    (async () => {
      try {
        const ref = doc(db, "outstation_rentals", id);
        const snap = await getDoc(ref);
        if (snap.exists()) {
          const data = { id: snap.id, ...snap.data() };

          // get car options (filter >0)
          let carOptions = [];
          if (data.vehiclePrices && typeof data.vehiclePrices === "object") {
            carOptions = Object.entries(data.vehiclePrices)
              .filter(([_, amount]) => parseInt(amount, 10) > 0)
              .map(([id, amount]) => ({
                id,
                amount: parseInt(amount, 10),
              }));
          }

          setPkg({ ...data, carOptions });

          // fetch vehicles info
          const vehicleIds = Object.entries(data.vehiclePrices || {})
            .filter(([_, price]) => Number(price) > 0)
            .map(([vehicleId]) => vehicleId);

          const fetchVehicles = async (ids) => {
            if (ids.length === 0) return [];
            const chunks = [];
            for (let i = 0; i < ids.length; i += 10) {
              const batch = ids.slice(i, i + 10);
              const q = query(
                collection(db, "vehicle_types"),
                where("__name__", "in", batch)
              );
              const snap = await getDocs(q);
              chunks.push(snap.docs.map((d) => ({ id: d.id, ...d.data() })));
            }
            return chunks.flat();
          };

          const vehicleData = await fetchVehicles(vehicleIds);
          setVehicles(vehicleData);
        }
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    })();
  }, [id]);

if (loading) {
  return (
    <Container fluid className="p-0"  style={{
      position: "fixed",
      top: 0,
      left: 0,
      width: "100%",
      height: "100%",
      overflow: "hidden",
      background: "#fff",
      
      transition: "opacity 0.3s ease",
    }}>
      <Container className="px-3 py-5">
        <Row className="gy-4">
          {/* LEFT: Carousel Skeleton */}
          <Col lg={7}>
            <div className="room-carousel-wrapper">
              {/* Main image skeleton */}
              <div
                style={{
                  width: "100%",
                  height: 250,
                  borderRadius: "15px",
                  backgroundColor: "#e9ecef",
                  
                }}
              ></div>

              {/* Thumbnail skeletons */}
              <div className="d-flex gap-2 mt-3">
                {[...Array(4)].map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: 90,
                      height: 70,
                      borderRadius: "8px",
                      backgroundColor: "#e9ecef",
                    }}
                  ></div>
                ))}
              </div>
            </div>
          </Col>

          {/* RIGHT: Info Card Skeleton */}
          <Col lg={5}>
            <Card className="p-4 shadow-sm border-0">
              <div
                style={{
                  width: "100%",
                  height: 50,
                  borderRadius: "8px",
                  backgroundColor: "#e9ecef",
                  marginBottom: "15px",
                }}
              ></div>
              <div
                style={{
                  width: "100%",
                  height: 180,
                  borderRadius: "8px",
                  backgroundColor: "#e9ecef",
                  marginBottom: "15px",
                }}
              ></div>

              {/* Vehicle grid skeleton */}
              <Row xs={2} md={4} className="g-3 mt-2">
                {[...Array(4)].map((_, i) => (
                  <Col key={i}>
                    <div
                      style={{
                        width: "100%",
                        height: 80,
                        borderRadius: "10px",
                        backgroundColor: "#e9ecef",
                      }}
                    ></div>
                  </Col>
                ))}
              </Row>

              <div
                style={{
                  width: "100%",
                  height: 45,
                  borderRadius: "8px",
                  backgroundColor: "#e9ecef",
                  marginTop: "20px",
                }}
              ></div>
            </Card>
          </Col>
        </Row>

        {/* Related Rentals Section */}
        <div className="mt-5">
          <Row className="g-3">
            {[...Array(3)].map((_, i) => (
              <Col key={i} md={4}>
                <div
                  style={{
                    width: "100%",
                    height: 220,
                    borderRadius: "12px",
                    backgroundColor: "#e9ecef",
                  }}
                ></div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </Container>
  );
}



  if (!pkg) {
    return (
      <Container className="py-5 text-center">
        <h4>Rental package not found</h4>
        <Button variant="link" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} /> Back
        </Button>
      </Container>
    );
  }

  const images = Array.isArray(pkg?.images) ? pkg.images : [];
  const minPrice = pkg?.carOptions?.length
    ? Math.min(...pkg.carOptions.map((c) => c.amount))
    : null;

  return (
    <Container fluid className="p-0">
    

      <Container className="px-3">
        <Row className="gy-4">
          <Col lg={7}>
            <div className="room-carousel-wrapper">
              <Carousel
                activeIndex={index}
                onSelect={(i) => setIndex(i)}
                variant="dark"
                className="mb-3 room-main-images"
              >
                {images.map((url, i) => (
                  <Carousel.Item key={i}>
                    {!imgLoaded[`main-${i}`] && (
                      <Placeholder
                        animation="glow"
                        style={{
                          width: "100%",
                          height: 400,
                          borderRadius: ".75rem",
                          backgroundColor: "#e9ecef",
                        }}
                      />
                    )}
                    <img
                      src={url}
                      className="d-block w-100 room-main-image"
                      alt={`Slide ${i + 1}`}
                      onLoad={() =>
                        setImgLoaded((prev) => ({
                          ...prev,
                          [`main-${i}`]: true,
                        }))
                      }
                      style={{
                        display: imgLoaded[`main-${i}`] ? "block" : "none",
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>
            <div className="room-thumbs d-flex gap-2">
              {images.map((url, i) => (
                <div
                  key={i}
                  onClick={() => setIndex(i)}
                  className={`thumb-container ${
                    index === i ? "thumb-active" : ""
                  }`}
                >
                  {!imgLoaded[`thumb-${i}`] && (
                    <Placeholder
                      animation="glow"
                      style={{
                        width: 90,
                        height: 70,
                        borderRadius: ".5rem",
                        backgroundColor: "#e9ecef",
                      }}
                    />
                  )}
                  <Image
                    src={url}
                    thumbnail
                    onLoad={() =>
                      setImgLoaded((prev) => ({
                        ...prev,
                        [`thumb-${i}`]: true,
                      }))
                    }
                    style={{
                      objectFit: "cover",
                      display: imgLoaded[`thumb-${i}`] ? "block" : "none",
                    }}
                  />
                </div>
              ))}
            </div>
          </Col>

          <Col lg={5}>
            <Card className="p-4 shadow-sm">
              <Card.Body>
                <Card.Title className="fw-bold mb-1">
                  {pkg.from} → {pkg.to}
                </Card.Title>
                {minPrice !== null && (
                  <h4 style={{ color: "#54b435" }}>
                    ₹{minPrice.toLocaleString()} onwards
                  </h4>
                )}

                <p
                  className="mt-3"
                  dangerouslySetInnerHTML={{ __html: pkg.description || "" }}
                />

                <strong style={{ color: "#54b435" }}>
                  Available Vehicles
                </strong>
                <div className="mt-3 mb-3">
                  {vehicles.length > 0 ? (
                    <Row xs={2} md={4} className="g-3">
                      {vehicles.map((car) => (
                        <Col key={car.id}>
                          <Card
                            className="text-center shadow-sm border-0 h-100"
                            style={{
                              borderRadius: "12px",
                              backgroundColor: "#e4e4e5",
                              cursor: "pointer",
                            }}
                          >
                            <Card.Body className="p-2">
                              <Image
                                src={car.image}
                                alt={car.name}
                                rounded
                                style={{
                                  width: "100%",
                                  height: "80px",
                                  objectFit: "cover",
                                  borderRadius: "10px",
                                }}
                              />
                              <div
                                className="fw-semibold mt-1"
                                style={{ fontSize: "12px" }}
                              >
                                {car.name}
                                <br />
                                Seats: {car.capacity}
                              </div>
                            </Card.Body>
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  ) : (
                    <p className="text-muted mt-2">
                      No vehicles available for this trip.
                    </p>
                  )}
                </div>

                <Button
                  size="lg"
                  className="w-100 btn-own"
                   onClick={() => {
                    if (!currentUser) {
                      // not logged in → show reminder instead of booking
                      setShowReminder(true);
                      
                    } else {
                     setBookingModal(true);
                    }
                  }}
                
                >
                  Book Rental
                </Button>
              </Card.Body>
            </Card>
          </Col>
        </Row>
        <br />
        <div style={{ marginBottom: '50px' }}>
          <RelatedRentals currentPackageId={pkg.id} />
        </div>
       
      </Container>

      <OutstationRentalModal
        show={bookingModal}
        onHide={() => setBookingModal(false)}
        vehicles={vehicles}
        vehiclePrices={pkg.vehiclePrices || {}}
        packageData={pkg}
        onSubmit={(data) => {
          console.log("Booking data:", data);
        }}
      />
       {showReminder && (
                      <ProfileReminder
                          show={showReminder}
                          onClose={() => setShowReminder(false)}
                          type="login"
                          auto={false}
                        />
                    )}
    </Container>
  );
}
